import { zodResolver } from '@hookform/resolvers/zod';
import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  EditableLegalClientSchema,
  IEditableLegalClient,
} from '../../../../../Interfaces/IEditLegalClient';
import {
  getEmptyLegalClient,
  ILegalClient,
} from '../../../../../Interfaces/ILegalClient';
import { IRealEstate } from '../../../../../Interfaces/IRealEstate';
import { EditLegalClient } from '../../../../LegalClient/EditLegalClient';

interface IProps {
  realEstateOnject: IRealEstate;
  setRealEstateObject: React.Dispatch<React.SetStateAction<IRealEstate>>;
  legalClientArray: ILegalClient[];
  setLegalClientArray: React.Dispatch<React.SetStateAction<ILegalClient[]>>;
}

export const LegalClientRealEstateManager: React.FC<IProps> = props => {
  const [legalClientEditObject, setLegalClientEditObject] = useState(() => {
    const existingManager = props.legalClientArray.find(
      x => x.idLegalClient === props.realEstateOnject.Manager_idPerson
    );
    if (existingManager) {
      return existingManager;
    } else {
      const newObject = getEmptyLegalClient(props.legalClientArray, 3);

      props.setRealEstateObject({
        ...props.realEstateOnject,
      });
      return newObject;
    }
  });

  useEffect(() => {
    const testObject = props.legalClientArray.find(
      x => x.idLegalClient === legalClientEditObject.idLegalClient
    );

    if (testObject === undefined) {
      props.setLegalClientArray([
        ...props.legalClientArray,
        legalClientEditObject,
      ]);
    } else {
      props.setLegalClientArray([
        ...props.legalClientArray.map(x =>
          x.idLegalClient === legalClientEditObject.idLegalClient
            ? legalClientEditObject
            : x
        ),
      ]);
    }
  }, [legalClientEditObject]);

  const methods = useForm<IEditableLegalClient>({
    mode: 'onChange',
    defaultValues: legalClientEditObject as IEditableLegalClient, // TODO: this is probably not right
    resolver: zodResolver(EditableLegalClientSchema),
  });

  const onSubmit = methods.handleSubmit(data => {
    setLegalClientEditObject({
      ...legalClientEditObject,
      ...(data as ILegalClient),
    });
  });

  return (
    <>
      <Typography variant='h5' sx={{ mt: 2, mb: 1 }}>
        Verwaltung
        <br />
        <Typography>
          Gibt es eine Hausverwaltung für das Objekt? Bitte tragen Sie ggf. die
          entsprechenden Kontaktinformationen ein.
        </Typography>
      </Typography>

      <FormProvider {...methods}>
        <form id='edit-legal-client-form' onSubmit={onSubmit} noValidate>
          <EditLegalClient disableCompanyLegalClient />
        </form>
      </FormProvider>
    </>
  );
};
